function priceFormat(price) {
  if (price % 100) {
    return `$${(price / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
  } else {
    return `$${(price / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}.00`;
  }
}

function changeVariant(event, id) {
  const container = event.target.closest('.product-card-wrapper');
  const variants = container.dataset.variants && JSON.parse(container.dataset.variants);
  const selectedVariant = variants.find((e) => e.id === id);

  if (selectedVariant) {
    // Update sold out state
    container.classList.toggle("sold-out", !selectedVariant.available);

    // Update image
    const image = container.querySelector('.media img');
    if (image) {
      image.removeAttribute('srcset');

      const selectedSwatch = container.querySelector(`#variant-color-${id}`);

      if (selectedSwatch && selectedSwatch.dataset.mfCollectionImage) {
        image.src = selectedSwatch.dataset.mfCollectionImage;
      } else {
        image.src = selectedVariant?.featured_image?.src
          ? `${selectedVariant.featured_image.src}&crop=center&width=600`
          : image.src;
      }
    } else {
      // Alternative image selector for other card types
      const altImage = container.querySelector('img[id^="product-card-img"]');
      if (altImage) {
        altImage.removeAttribute('srcset');

        const selectedSwatch = container.querySelector(`#variant-color-${id}`);

        if (selectedSwatch && selectedSwatch.dataset.mfCollectionImage) {
          altImage.src = selectedSwatch.dataset.mfCollectionImage;
        } else {
          altImage.src = selectedVariant?.featured_image?.src
            ? `${selectedVariant.featured_image.src}&crop=center&width=600`
            : altImage.src;
        }
      }
    }

    // Update sale state
    const priceElement = container.querySelector('.price');
    const isOnSale = selectedVariant.compare_at_price > selectedVariant.price;
    container.classList.toggle("on-sale", isOnSale);
    if (priceElement) {
      priceElement.classList.toggle("price--on-sale", isOnSale);
    }

    // Update prices
    const regularPrice = container.querySelector('.price__regular .price-item');
    const saleCompareAtPrice = container.querySelector('.price__sale s');
    const salePrice = container.querySelector('.price__sale .price-item--sale');

    if (regularPrice) {
      regularPrice.innerText = `${priceFormat(selectedVariant.price)}`;

      if (selectedVariant.compare_at_price > 0) {
        if (saleCompareAtPrice) {
          saleCompareAtPrice.innerText = `${priceFormat(selectedVariant.compare_at_price)}`;
        }
        if (salePrice) {
          salePrice.innerText = `${priceFormat(selectedVariant.price)}`;
        }
      }
    } else {
      // Alternative price structure
      const priceElement = container.querySelector(`#price-${container.dataset.productId}`);
      const comparePriceElement = container.querySelector(`#compare-price-${container.dataset.productId}`);

      if (priceElement) {
        priceElement.innerText = priceFormat(selectedVariant.price);

        if (comparePriceElement) {
          if (selectedVariant.compare_at_price > selectedVariant.price) {
            comparePriceElement.innerText = priceFormat(selectedVariant.compare_at_price);
            comparePriceElement.style.display = 'inline';
          } else {
            comparePriceElement.style.display = 'none';
          }
        }
      }
    }

    // Update variant selection
    const variant_options = container.querySelectorAll('.variant-option');
    variant_options.forEach(option => {
      option.classList.remove('selected-variant');
      if (parseInt(option.dataset.variant, 10) === selectedVariant.id) {
        option.classList.add('selected-variant');
      }
    });

    // Update links
    const dataBaseUrlLinks = container.querySelectorAll('a[data-base-url]');
    dataBaseUrlLinks.forEach(link => {
      if (link.dataset.baseUrl) {
        link.href = link.dataset.baseUrl + id;
      }
    });

    // Update PLP card link
    const card_link = container.querySelector('.card-link');
    if (card_link && card_link.dataset.urlBase) {
      card_link.href = `${card_link.dataset.urlBase}?variant=${selectedVariant.id}`;
    }

    container.querySelectorAll('.custom-sales-slot').forEach((slot) => {
      slot.hidden = parseInt(slot.dataset.salesVariantId, 10) !== parseInt(id, 10);
    });
  }
}
